import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';


class Template extends Component {


    render() {
        return (
            <div>
                <Banner
                    headText="ADD HEADER TEXT HERE"
                    subHeadText="Add sub header text here"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-9 col-md-6 col-sm-12">
                                <p>Content goes here</p>
                            </div>




                            <InsideContact />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Template);


// WEBPACK FOOTER //
// ./src/components/Template.js